import React from 'react';
import { getImgSrc } from '../../services/common/CommonUtils';

const OfferBanner = ({ data }) => {
  return (
    <div className="sub_full_bg_banner_comp">
      <div className="banner_icon">
        <div className="offer">
          {/* <img
            src={process.env.PUBLIC_URL + '/assets/images/start.svg'}
            alt=""
            title=""
          /> */}
        </div>
        <img
          // src={
          //   data?.response?.icon ||
          //   process.env.PUBLIC_URL + '/assets/images/s-internet.svg'
          // }
          src={getImgSrc(data?.response?.icon, true)}
          alt=""
          title=""
        />
      </div>
    </div>
  );
};

export default OfferBanner;
